import type { IAnalyticMetric } from '~/types/metric';
import type { ChannelStats } from '~/types/graphql';

import { TARGET_CHANNEL } from '~/constants/campaign';
import { mapBarChartDataSeries } from '../../helpers';

export const getChannelLabel = (key: string): string =>
  key === 'direct' ? 'Direct' : (TARGET_CHANNEL.find((k) => k.value === key)?.label ?? key);

export const useChannelDataSeries = () => {
  const defaultChannels: ChannelStats[] = [
    { totalCount: 0, type: 'direct' },
    { totalCount: 0, type: 'email' },
    { totalCount: 0, type: 'referral' },
    { totalCount: 0, type: 'organic-social' },
    { totalCount: 0, type: 'organic-search' },
    { totalCount: 0, type: 'paid-social' },
    { totalCount: 0, type: 'paid-search' },
    { totalCount: 0, type: 'sms' },
  ];

  const mapChannelData = (metric?: IAnalyticMetric) => {
    const mergedChannels = defaultChannels
      .map((defaultChannel) => {
        const matchedChannel = metric?.channels?.find(
          (channel) => channel?.type === defaultChannel.type,
        );
        return {
          ...defaultChannel,
          totalCount: matchedChannel ? matchedChannel.totalCount : defaultChannel.totalCount,
        };
      })
      .filter((channel) => channel.totalCount > 0 || channel.type === 'direct');

    return mapBarChartDataSeries<ChannelStats>(mergedChannels, getChannelLabel);
  };

  return { mapChannelData };
};
